export const IS_GHOSTNET = process.env.REACT_APP_NETWORK !== 'atlasnet'

export const PROD_MAVEN_URL = 'https://atlasnet.mavenfinance.io'
export const DEV_MAVEN_URL = 'https://front-dev.mavryk-finance-dapp-frontend.pages.dev'
export const EXPLORER_MAIN_LINK = 'https://nexus.mavryk.org'
